import {
  Outlet,
  createRootRouteWithContext,
  CatchBoundary,
  HeadContent,
} from '@tanstack/react-router';
// import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools';
// import { TanStackDevtools } from '@tanstack/react-devtools';
// import TanStackQueryDevtools from '../integrations/tanstack-query/devtools';
import type { QueryClient } from '@tanstack/react-query';
import { NuqsAdapter } from 'nuqs/adapters/tanstack-router';
import { Toaster } from '@repo/ui/components/toaster';
import { ErrorComponent } from '@/components/ErrorComponent.tsx';
import { Sentry } from '@/integrations/sentry';

export interface MyRouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: () => (
    <CatchBoundary
      getResetKey={() => 'reset'}
      onCatch={(error) => {
        console.error('Hit error boundary', error);
        Sentry.captureException(error);
      }}
      errorComponent={() => <ErrorComponent />}
    >
      <NuqsAdapter>
        <HeadContent />
        <Outlet />
        <Toaster />
        {/*<TanStackDevtools*/}
        {/*  config={{*/}
        {/*    position: 'top-right',*/}
        {/*  }}*/}
        {/*  plugins={[*/}
        {/*    {*/}
        {/*      name: 'Tanstack Router',*/}
        {/*      render: <TanStackRouterDevtoolsPanel />,*/}
        {/*    },*/}
        {/*    TanStackQueryDevtools,*/}
        {/*  ]}*/}
        {/*/>*/}
      </NuqsAdapter>
    </CatchBoundary>
  ),
});
